import withStyles from '@material-ui/core/styles/withStyles'
import MuiButton from '@material-ui/core/Button'

export const TileButton = withStyles({
  root: {
    borderRadius: 0
  },
  label: {
    textTransform: 'none',
    textAlign: 'left'
  }
})(MuiButton)

export default TileButton
